/**
 * Shared constants and helpers for the QualificationModal (Form 2 / VSL Gate).
 * Extracted from QualificationModal.jsx (2026-07-29 refactor) to reduce that
 * component's size and enable independent testing.
 */

// Localstorage / sessionstorage keys — SINGLE SOURCE OF TRUTH.
export const STORAGE_LEAD_ID = 'gp_vsl_lead_id';
export const STORAGE_PHASE1 = 'gp_vsl_phase1';
export const STORAGE_QUALIFICA_DONE = 'gp_qualifica_done';
export const STORAGE_FORM_DRAFT = 'gp_qualifica_draft';
export const STORAGE_ORGANIC_PREFILL = 'gp_organic_prefill';
export const STORAGE_ORGANIC_LEAD_ID = 'gp_organic_lead_id';

// Step ids in order — 'success' is terminal.
export const STEPS = ['contact', 'path', 'countries', 'budget', 'timeline', 'success'];

// Which countries are available for each path.
//   • real_estate → solo Albania + Indonesia (Thailandia non ha real estate)
//   • equity_share → tutti e tre i paesi
//   • both → solo Albania + Indonesia (perché RE richiede ambo paesi)
export const COUNTRIES_BY_PATH = {
  real_estate: ['albania', 'indonesia'],
  equity_share: ['albania', 'indonesia', 'thailandia'],
  both: ['albania', 'indonesia'],
};

/**
 * Return the budget option list for the currently selected path.
 * Falls back to []`` if config is not yet loaded.
 */
export function budgetOptionsForPath(config, path) {
  if (!config) return [];
  if (path === 'real_estate') return config.budget.real_estate;
  if (path === 'equity_share') return config.budget.equity_share;
  if (path === 'both') {
    // Both paths → show the union starting with real_estate (lower floor)
    return config.budget.real_estate;
  }
  return [];
}

/**
 * Extract UTM parameters from the current URL — best effort.
 */
export function extractUtm() {
  const utm = {};
  if (typeof window === 'undefined') return utm;
  try {
    const qs = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gp_track'].forEach((k) => {
      const v = qs.get(k);
      if (v) utm[k] = v;
    });
  } catch {
    /* URL parsing not critical — ignore */
  }
  return utm;
}

/**
 * Per-step validation. Returns true if the user can proceed from `stepKey`.
 */
export function canContinueForStep(stepKey, form) {
  if (stepKey === 'contact') {
    const phoneOk = !!form.phone_e164 && /^\+\d{1,4}\d{6,}$/.test(form.phone_e164);
    return (
      form.first_name.trim().length > 1 &&
      form.last_name.trim().length > 1 &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim()) &&
      phoneOk
    );
  }
  if (stepKey === 'countries') return form.countries.length > 0;
  if (stepKey === 'path') return !!form.path;
  if (stepKey === 'budget') return !!form.budget_bracket;
  if (stepKey === 'timeline') return !!form.timeline;
  return true;
}

/**
 * Default initial form state — kept here so tests can import & assert.
 */
export const INITIAL_FORM = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  phone_e164: '',
  phone_country_code: 'IT',
  countries: [],
  path: '',
  budget_bracket: '',
  timeline: '',
};
